/* globals window */

'use strict';

module.exports = window.DealLazyLoader = {
  init: (payload, done) => {
    document.body.addEventListener('modal-open', e => {
      const { detail: id } = e;
      window.Groupon.Utils.lazyLoadImages(
        document.querySelector(`#${id}`).querySelectorAll('.lazy-load')
      );
      window.Groupon.Utils.lazyLoadImages(`#${id} .lazy-load`);
    });

    window.Groupon.Utils.lazyLoadImages('.sleepy-load:not(.lazy-loaded)', {
      skip_invisible: true,
    });

    window.Groupon.Utils.lazyLoadImages('.lazy-load:not(.lazy-loaded)', {
      skip_invisible: true,
    });

    done();
  },
};
